import { render, staticRenderFns } from "./app-item-create.vue?vue&type=template&id=45f7c30c&scoped=true&"
import script from "./app-item-create.js?vue&type=script&lang=js&"
export * from "./app-item-create.js?vue&type=script&lang=js&"
import style0 from "./app-item-create.scss?vue&type=style&index=0&id=45f7c30c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f7c30c",
  null
  
)

component.options.__file = "app-item-create.vue"
export default component.exports